export const locale = s => {
  return s;
};
